export default __webpack_public_path__ + "static/shape-8ad9fd9975b9e96cc0191aa35613109b.png";